import { Flex, Container, Heading, Text, Button, Box, Image } from '@chakra-ui/react';
import { useNavigate } from 'react-router';
import Logo from '@components/Logo';
import Error404Image from '@assets/error_404.svg'

const NotFound = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/painel', { replace: true });
  };

  return (
    <Container maxW="5xl" py={10}>
      <Flex direction="column" align="center" gap={3}>
        <Logo width={100} />

        <Image
          src={Error404Image}
          alt="Erro 404 - Página não encontrada"
          width={{ base: '100%', md: 400 }}
        />

        <Box textAlign="center" mt={4}>
          <Heading>
            Página não encontrada
          </Heading>
          <Text>
            Desculpe, mas a página que você está procurando não existe.
          </Text>
        </Box>
        
        <Button mt={4} colorPalette="argos" onClick={handleGoHome}>
          Voltar para a página inicial
        </Button>
      </Flex>
    </Container>
  );
};

export default NotFound;
